import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Navbar from "../../components/common/Navbar";
import Footer from "../../components/common/Footer";

const SkilledEmployeeHiringServices = () => {
  return (
    <main>

      <Helmet>
        <title>
        Hire Skilled Employees in India | Top Staffing Solutions Company
        </title>

        <meta
          name="description"
          content="Find skilled employees and manpower recruitment services for your business with trusted staffing solutions from BusinessMateWorkflow™."
        />

        <meta
          name="keywords"
          content="hire skilled employees,manpower recruitment services,staffing solutions company,employee hiring services,skilled workforce provider"
        />

        <link
          rel="canonical"
          href="https://www.businessmateworkflow.in/skilled-employee-hiring-services"
        />

        <meta
          property="og:title"
          content="Skilled Employee Hiring Services"
        />

        <meta
          property="og:description"
          content="Connect with skilled professionals and simplify your hiring process across multiple industries."
        />

        <meta
          property="og:image"
          content="https://www.businessmateworkflow.in/uploads/profile-photos/profile-1762338957065-196649575.png"
        />

        <meta
          property="og:url"
          content="https://www.businessmateworkflow.in/skilled-employee-hiring-services"
        />

      </Helmet>

      <Navbar />

      {/* HERO SECTION */}
      <section
        style={{
          background:
            "linear-gradient(135deg, #0f172a 0%, #1e293b 100%)",
          padding: "40px 0",
          color: "#fff",
        }}
      >
        <div className="container">
          <div className="row align-items-center">

            {/* LEFT CONTENT */}
            <div className="col-lg-6">

              <span
                style={{
                  background: "#06b590",
                  padding: "8px 18px",
                  borderRadius: "30px",
                  fontSize: "14px",
                  fontWeight: "600",
                  display: "inline-block",
                  marginBottom: "20px",
                }}
              >
                Recruitment & Staffing Solutions
              </span>

              <h1
                style={{
                  fontSize: "52px",
                  fontWeight: "800",
                  lineHeight: "1.2",
                  marginBottom: "25px",
                  color: "#fff",
                }}
              >
                Hire Skilled Employees for Your Business Growth
              </h1>

              <p
                style={{
                  fontSize: "17px",
                  lineHeight: "2",
                  color: "#cbd5e1",
                }}
              >
                Every successful business depends on the strength of its workforce. Finding skilled employees with the right experience, dedication, and capabilities is one of the biggest challenges businesses face today.
              </p>

              <p
                style={{
                  fontSize: "17px",
                  lineHeight: "2",
                  color: "#cbd5e1",
                  marginTop: "15px",
                }}
              >
                At BusinessMateWorkflow™, our Skilled Employee Services are designed to help companies connect with talented professionals across different industries. We help businesses simplify the hiring process by providing access to organized candidate profiles and workforce support solutions.
              </p>

            </div>

            {/* RIGHT IMAGE */}
            <div className="col-lg-6 text-center mt-5 mt-lg-0">

              <img
                src="/uploads/profile-photos/profile-1762338957065-196649575.png"
                alt="Skilled Employee Hiring Services"
                className="img-fluid"
                loading="lazy"
                style={{
                  borderRadius: "25px",
                  boxShadow: "0 25px 60px rgba(0,0,0,0.35)",
                  maxHeight: "550px",
                  objectFit: "cover",
                }}
              />

            </div>

          </div>
        </div>
      </section>

      {/* HIRING SUPPORT SECTION */}
      <section
        style={{
          padding: "100px 0",
          background: "#f8fafc",
        }}
      >
        <div className="container">

          <div className="text-center mb-5">
            <h2
              style={{
                fontSize: "42px",
                fontWeight: "800",
                marginBottom: "20px",
              }}
            >
              Our Hiring Support Includes
            </h2>
          </div>

          <div className="row g-4">
            <div className="col-lg-4 col-md-6">
              <div
                style={{
                  background: "#fff",
                  padding: "30px",
                  borderRadius: "20px",
                  textAlign: "center",
                  height: "100%",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                        marginBottom: "15px"
                }}
              >
                <div style={{ fontSize: "40px", marginBottom: "15px" }}>👥</div>
                <h3 style={{ fontWeight: "700", fontSize: "18px", marginBottom: "0" }}>
                  Skilled employee hiring support
                </h3>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div
                style={{
                  background: "#fff",
                  padding: "30px",
                  borderRadius: "20px",
                  textAlign: "center",
                  height: "100%",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                }}
              >
                <div style={{ fontSize: "40px", marginBottom: "15px" }}>⚙️</div>
                <h3 style={{ fontWeight: "700", fontSize: "18px", marginBottom: "0" }}>
                  Workforce and staffing solutions
                </h3>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div
                style={{
                  background: "#fff",
                  padding: "30px",
                  borderRadius: "20px",
                  textAlign: "center",
                  height: "100%",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                }}
              >
                <div style={{ fontSize: "40px", marginBottom: "15px" }}>📄</div>
                <h3 style={{ fontWeight: "700", fontSize: "18px", marginBottom: "0" }}>
                  Candidate profile sharing
                </h3>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div
                style={{
                  background: "#fff",
                  padding: "30px",
                  borderRadius: "20px",
                  textAlign: "center",
                  height: "100%",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                }}
              >
                <div style={{ fontSize: "40px", marginBottom: "15px" }}>🎯</div>
                <h3 style={{ fontWeight: "700", fontSize: "18px", marginBottom: "0" }}>
                  Industry-based talent matching
                </h3>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div
                style={{
                  background: "#fff",
                  padding: "30px",
                  borderRadius: "20px",
                  textAlign: "center",
                  height: "100%",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                }}
              >
                <div style={{ fontSize: "40px", marginBottom: "15px" }}>💼</div>
                <h3 style={{ fontWeight: "700", fontSize: "18px", marginBottom: "0" }}>
                  Freelancer and project-based hiring support
                </h3>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div
                style={{
                  background: "#fff",
                  padding: "30px",
                  borderRadius: "20px",
                  textAlign: "center",
                  height: "100%",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                }}
              >
                <div style={{ fontSize: "40px", marginBottom: "15px" }}>📈</div>
                <h3 style={{ fontWeight: "700", fontSize: "18px", marginBottom: "0" }}>
                  Business workforce expansion assistance
                </h3>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* BENEFITS FOR BUSINESSES SECTION */}
      <section
        style={{
          padding: "100px 0",
          background: "#fff",
        }}
      >
        <div className="container">

          <div className="row align-items-center">
            <div className="col-lg-6">
              <h2
                style={{
                  fontSize: "42px",
                  fontWeight: "800",
                  marginBottom: "25px",
                }}
              >
                Benefits for Businesses
              </h2>

              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                }}
              >
                <li className="mb-3" style={{ fontSize: "18px", color: "#475569" }}>
                  ✅ Faster access to skilled candidates
                </li>
                <li className="mb-3" style={{ fontSize: "18px", color: "#475569" }}>
                  ✅ Reduced hiring time
                </li>
                <li className="mb-3" style={{ fontSize: "18px", color: "#475569" }}>
                  ✅ Better workforce management
                </li>
                <li className="mb-3" style={{ fontSize: "18px", color: "#475569" }}>
                  ✅ Multiple hiring options
                </li>
                <li className="mb-3" style={{ fontSize: "18px", color: "#475569" }}>
                  ✅ Access to professionals from various industries
                </li>
              </ul>

              <p
                style={{
                  fontSize: "17px",
                  lineHeight: "1.8",
                  color: "#475569",
                  marginTop: "20px",
                  padding: "20px",
                  background: "#f8fafc",
                  borderRadius: "15px",
                }}
              >
                If your business also requires outsourcing or operational support, you can explore our Third-Party Business Services for additional business solutions.
              </p>
            </div>

            <div className="col-lg-6 mt-5 mt-lg-0">
              <div
                style={{
                  background: "#06b590",
                  padding: "40px",
                  borderRadius: "25px",
                  color: "#fff",
                  textAlign: "center",
                }}
              >
                <div style={{ fontSize: "60px", marginBottom: "20px" }}>🏆</div>
                <h3 style={{ fontSize: "28px", fontWeight: "700", marginBottom: "15px" }}>
                  Why Businesses Choose Us
                </h3>
                <p style={{ fontSize: "17px", lineHeight: "1.8", opacity: "0.95" }}>
                  Businesses choose our platform because we focus on structured connections, organized candidate management, and business growth support. We aim to simplify hiring while helping businesses save time and improve workforce quality.
                </p>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* PLATFORM CONNECTION SECTION */}
      <section
        style={{
          padding: "80px 0",
          background: "#f8fafc",
        }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div
                style={{
                  background: "#fff",
                  padding: "50px",
                  borderRadius: "25px",
                  textAlign: "center",
                  boxShadow: "0 10px 40px rgba(0,0,0,0.08)",
                }}
              >
                <div style={{ fontSize: "50px", marginBottom: "20px" }}>🌉</div>
                <h3
                  style={{
                    fontSize: "28px",
                    fontWeight: "700",
                    marginBottom: "20px",
                  }}
                >
                  Our platform acts as a connection bridge between employers and job seekers
                </h3>
                <p
                  style={{
                    fontSize: "17px",
                    lineHeight: "1.8",
                    color: "#475569",
                  }}
                >
                  helping companies find suitable employees while also helping candidates discover better career opportunities.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section
        style={{
          background:
            "linear-gradient(135deg, #06b590 0%, #059669 100%)",
          padding: "90px 0",
          textAlign: "center",
          color: "#fff",
        }}
      >
        <div className="container">

          <h2
            style={{
              fontSize: "48px",
              fontWeight: "800",
              marginBottom: "20px",
            }}
          >
            Start Your Business Journey Today
          </h2>

          <p
            style={{
              maxWidth: "800px",
              margin: "0 auto",
              fontSize: "18px",
              lineHeight: "1.9",
              marginBottom: "35px",
            }}
          >
            If you are looking for business opportunities, partnerships, employees, or professional services, you can contact us. Our team will understand your requirement and connect you with the right solution.
          </p>

          <Link to="/contact">
            <button
              className="btn"
              style={{
                background: "#fff",
                color: "#06b590",
                padding: "15px 40px",
                borderRadius: "12px",
                fontWeight: "700",
                border: "none",
                fontSize: "18px",
              }}
            >
              Get Started Now
            </button>
          </Link>

        </div>
      </section>

      <Footer />

    </main>
  );
};

export default SkilledEmployeeHiringServices;